import dayjs from "dayjs";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../components/buttons/button";
import { ProfileIcon } from "../../../components/cards/profilePic";
import { PopoverMenu } from "../../../components/dropdown/popover";
import { CaretDown } from "../../../components/icon/downcaret";
import { TableComponent } from "../../../components/table";
import { BgWrapper } from "../../../components/wrapper/bgWrapper";
import { useMonthlyDates } from "../../../customeHooks/useMonthlyDates";
import { useGetAllSalesPerformanceQuery } from "../../../redux/features/admin/sales/sales.api";
import { SalesPerformanceQuery } from "../../../redux/features/admin/sales/sales.types";
import { formatDate, formatToCurrency } from "../../../utils/helpers";

export const SalesPerformannce = () => {
  const [query, setQuery] = useState<SalesPerformanceQuery>({
    page: 1,
    limit: 50,
    search: undefined,
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
  });

  const navigate = useNavigate();

  const { months } = useMonthlyDates({
    initialDate: dayjs(),
    minDate: dayjs("2025-09-30"), //start from Oct 2025
    maxDate: dayjs(
      `${new Date().getFullYear()}-${new Date().getMonth() + 2}-01`,
    ),
  });

  const { isFetching: fetchingSalesPerformance, data: salesPerformance } =
    useGetAllSalesPerformanceQuery(
      { ...query, search: query.search === "" ? undefined : query.search },
      {
        refetchOnMountOrArgChange: true,
      },
    );

  return (
    <div className="flex flex-col gap-[2px] md:min-h-0 md:flex-1">
      <BgWrapper className="flex flex-row items-center justify-between gap-[10px]">
        <PopoverMenu
          menuItems={[...months].reverse().map((month) => {
            return {
              name: formatDate(month.start.toString(), "MMMM YYYY"),
              value: "",
              onClick: () => {
                setQuery({
                  ...query,
                  page: 1,
                  month: month.start.month() + 1,
                  year: month.start.year(),
                });
              },
            };
          })}
          menuClassName="!min-w-[230px] shadow-md !rounded-[8px]"
          menuItemsClassName="!font-bold !py-4"
          position="bottom start"
          closeOnClick
        >
          <Button
            type="button"
            text={`${formatDate(`${query.year}-${query.month}-01`, "MMMM YYYY")}`}
            className="!border-0 !p-0 !px-0 !py-0"
            variation="plain"
            extra={<CaretDown />}
          />
        </PopoverMenu>
      </BgWrapper>

      <BgWrapper className="flex flex-col gap-3 md:min-h-0 md:flex-1">
        <TableComponent
          headers={[]}
          rows={
            salesPerformance?.data?.data?.map((agent, idx) => {
              return {
                id: idx,
                items: [
                  <div
                    className={`flex w-full flex-1 flex-col gap-2 md:flex-row md:items-center`}
                  >
                    <div className="flex items-center justify-between gap-2">
                      <ProfileIcon img="" dimension={32} className="" />
                    </div>

                    <p className="flex flex-1 flex-wrap items-center gap-0 text-sm text-grey-600">
                      <span className="font-bold text-grey-900">
                        {agent.agentName}
                      </span>
                      <span className={` `}>∙</span>
                      <span className={``}>{agent.email}</span>
                    </p>

                    <p className="fonnt-bold flex flex-row flex-wrap items-center gap-1 font-bold text-primary">
                      <span className="">
                        {formatToCurrency(agent.totalCommissionNGN, {
                          currency: "NGN",
                        })}
                      </span>
                      <span className={` `}>∙</span>
                      <span className={``}>
                        {formatToCurrency(agent.totalCommissionCAD, {
                          currency: "CAD",
                        })}
                      </span>
                      <span>&nbsp;Earnend</span>
                    </p>
                  </div>,
                ],
              };
            }) ?? []
          }
          loadingRows={query.limit}
          isLoading={fetchingSalesPerformance}
          isRowClickable
          onRowClick={(idx) => {
            navigate(`/sales/agent/${salesPerformance?.data?.data[idx]?._id}`);
          }}
          isTableEmpty={[0, undefined].includes(
            salesPerformance?.data?.data?.length,
          )}
          emptyTitle="No Sales Agents"
          emptySubTitle=""
          emptyImage="/assets/images/guest-glass.png"
          isPaginated
          currentPage={query.page ?? 1}
          totalCount={salesPerformance?.data?.totalCount ?? 0}
          itemsPerPage={query.limit!}
          pageRangeDisplayed={3}
          onPageChange={(page) => {
            setQuery({
              ...query,
              page: page,
            });
          }}
          className=""
        />
      </BgWrapper>
    </div>
  );
};
